import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

const schema = Yup.object().shape({
  name: Yup.string().trim().required("Menu name is required"),
  key: Yup.string().trim().required("Menu key is required"),
  path: Yup.string().trim().required("Menu path is required"),
  icon: Yup.string().trim(),
  order: Yup.number().typeError("Order must be numeric").min(0, "Order cannot be negative"),
});

export default function MenuForm({
  initialValues,
  onSubmit,
  onCancel,
  parentOptions = [],
  submitLabel = "Save Menu",
  externalSubmitting = false,
}) {
  const defaults = {
    name: "",
    key: "",
    path: "",
    icon: "fa-circle",
    parentId: "",
    order: 0,
    isActive: true,
    ...initialValues,
  };

  return (
    <Formik initialValues={defaults} enableReinitialize validationSchema={schema} onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="text-label">Menu Name</label>
              <input className="form-control" name="name" value={values.name} onChange={handleChange} onBlur={handleBlur} />
              {touched.name && errors.name && <small className="text-danger">{errors.name}</small>}
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-label">Menu Key</label>
              <input className="form-control" name="key" value={values.key} onChange={handleChange} onBlur={handleBlur} />
              {touched.key && errors.key && <small className="text-danger">{errors.key}</small>}
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-label">Path</label>
              <input className="form-control" name="path" value={values.path} onChange={handleChange} onBlur={handleBlur} placeholder="/menu-list" />
              {touched.path && errors.path && <small className="text-danger">{errors.path}</small>}
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-label">Icon</label>
              <input className="form-control" name="icon" value={values.icon} onChange={handleChange} onBlur={handleBlur} placeholder="fa-list" />
            </div>
            <div className="col-md-6 mb-3">
              <label className="text-label">Parent Menu</label>
              <select className="form-control" name="parentId" value={values.parentId || ""} onChange={handleChange}>
                <option value="">None (root)</option>
                {parentOptions.map((p) => (
                  <option key={p._id} value={p._id}>
                    {p.name} ({p.path})
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3 mb-3">
              <label className="text-label">Order</label>
              <input className="form-control" name="order" type="number" value={values.order} onChange={handleChange} onBlur={handleBlur} />
            </div>
            <div className="col-md-3 mb-3 d-flex align-items-end">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" name="isActive" checked={Boolean(values.isActive)} onChange={handleChange} />
                <label className="form-check-label">Active</label>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-primary" type="submit" disabled={isSubmitting || externalSubmitting}>
              {isSubmitting || externalSubmitting ? "Saving..." : submitLabel}
            </button>
            <button className="btn btn-outline-secondary" type="button" onClick={() => resetForm()}>
              Reset
            </button>
            {onCancel && (
              <button className="btn btn-light" type="button" onClick={onCancel}>
                Cancel
              </button>
            )}
          </div>
        </form>
      )}
    </Formik>
  );
}
